import styled from 'styled-components';

import { Button } from '@naf/button';
import { borderRadius, spacing } from '@naf/theme';

export const StyledButton = styled(Button)`
  min-width: 212px;
  height: ${spacing.space48};
  border-radius: ${borderRadius.L};
  gap: ${spacing.space12};
  padding: ${spacing.space16} ${spacing.space24};
`;
